var initialState = {
  loading: false,
  error: false,
  public: {},
  custom: {}
};
export default initialState;